export const NO_RESULT_AVAILABLE = 'NO_RESULT_AVAILABLE'
export const AWAITING_RESULT = 'AWAITING_RESULT'
export const REQUEST_CANCELLED = 'REQUEST_CANCELLED'
export const RESULT_RECEIVED = 'RESULT_RECEIVED'
export const RESULT_EXPIRED = 'RESULT_EXPIRED'
export const CLEAR_CACHE = 'CLEAR_CACHE'
export const CLEAR_CACHE_ITEM = 'CLEAR_CACHE_ITEM'
